import axios, { AxiosResponse } from 'axios';
import {
  PayerListResponse,
  PayerSummary,
  EditPayerRequest,
  EditPayerResponse,
  DeletePayerResponse,
  CreatePayerRequest,
  CreatePayerResponse,
  PayerDetailsResponse,
} from './types';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const payerApi = {
  // Get all payers (Admin endpoint)
  getAllPayers: async (
    limit?: number,
    offset?: number,
    payerName?: string,
    payerAccountNumber?: string,
    payerEmail?: string
  ): Promise<PayerListResponse> => {
    const params = new URLSearchParams();

    if (limit !== undefined) params.append('limit', limit.toString());
    if (offset !== undefined) params.append('offset', offset.toString());
    if (payerName) params.append('payerName', payerName);
    if (payerAccountNumber) params.append('payerAccountNumber', payerAccountNumber);
    if (payerEmail) params.append('payerEmail', payerEmail);

    const queryString = params.toString();
    const url = `/admin/protectpay/payers${queryString ? `?${queryString}` : ''}`;

    const response: AxiosResponse<PayerListResponse> = await apiClient.get(url);
    return response.data;
  },

  // Get specific payer details (Admin endpoint)
  getPayerDetails: async (payerId: string): Promise<PayerDetailsResponse> => {
    const response: AxiosResponse<PayerDetailsResponse> = await apiClient.get(
      `/admin/protectpay/payers/${payerId}`
    );
    return response.data;
  },

  // Create payer (Main ProtectPay endpoint with Basic auth)
  createPayer: async (
    request: CreatePayerRequest,
    billerId: string,
    authToken: string
  ): Promise<CreatePayerResponse> => {
    const authHeader = `Basic ${btoa(`${billerId}:${authToken}`)}`;
    const response: AxiosResponse<CreatePayerResponse> = await apiClient.put(
      '/protectpay/Payers',
      request,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
    return response.data;
  },

  // Edit payer (Admin endpoint)
  editPayer: async (payerId: string, request: EditPayerRequest): Promise<EditPayerResponse> => {
    const response: AxiosResponse<EditPayerResponse> = await apiClient.post(
      `/admin/protectpay/payers/${payerId}`,
      request
    );
    return response.data;
  },

  // Delete payer (Admin endpoint)
  deletePayer: async (payerId: string): Promise<DeletePayerResponse> => {
    const response: AxiosResponse<DeletePayerResponse> = await apiClient.delete(
      `/admin/protectpay/payers/${payerId}`
    );
    return response.data;
  },
};
